<template>
  <el-dialog
    :title="title"
    :visible.sync="$parent.fontEditDialogStatus"
    class="del-dialog"
  >
    <span slot="footer" class="dialog-footer btn-wrap">
      <el-button @click="$parent.fontEditDialogStatus = false">
        取 消
      </el-button>
      <el-button type="primary" @click.stop="edit">{{ confirmtext }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    confirmtext: {
      type: String,
      default: "确 认",
    },
  },
  methods: {
    edit() {
      this.$emit("edit");
    },
  },
};
</script>
